import React from "react"
import { getImage } from "gatsby-plugin-image"
import { BgImage } from "gbimage-bridge"

const GbiBridged = ({ children, image }) => {
  const result = getImage(image)

  const backgroundFluidImageStack = [result, `linear-gradient(0deg,rgba(0,0,0,0.8) 0%,rgba(0,0,0,0.6) 100%)`].reverse()

  return (
    <BgImage image={backgroundFluidImageStack} style={{ minWidth: 200, minHeight: 200 }}>
      {children}
    </BgImage>
  )
}
export default GbiBridged
